// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_botaoPopupSalvar__oaqKt {
  width: 180px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.styles_botaoPopupSalvar__oaqKt:hover {
  transform: scale(0.95) !important;
}

.styles_acoesForm__mQHd3 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 8px;
  padding-top: 4px;
}

.styles_botaoPopupCancelar__2MIiL {
  width: 180px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
}

.styles_botaoPopupCancelar__2MIiL:hover {
  transform: scale(0.95) !important;
}

.styles_formContent__IiL0m {
  flex-grow: 1;
}

.styles_formContainer__f-0pR {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.styles_formDiv__-x2nQ {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
.styles_campoNumero__patFJ {
  width: 120px !important;
}

.styles_filtrosTitulo__IBD9Z {
  margin-bottom: 8px !important;
  font-weight: 600 !important;
}

.styles_filtrosVazio__h-H4- {
  padding: 8px 0 !important;
}

.styles_filtrosLoading__O6UXU {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}

/* Cabeçalho + até 5 linhas visíveis; rolagem se houver mais linhas ou conteúdo largo */
.styles_tabelaFiltros__UtHJe {
  max-height: calc(48px + 5 * 2.5rem);
  overflow-y: auto;
  overflow-x: auto;
}`, "",{"version":3,"sources":["webpack://./src/forms/ContaDominioForm/styles.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA,uFAAuF;AACvF;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".botaoPopupSalvar {\n  width: 180px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n}\n\n.botaoPopupSalvar:hover {\n  transform: scale(0.95) !important;\n}\n\n.acoesForm {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: 8px;\n  padding-top: 4px;\n}\n\n.botaoPopupCancelar {\n  width: 180px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n}\n\n.botaoPopupCancelar:hover {\n  transform: scale(0.95) !important;\n}\n\n.formContent {\n  flex-grow: 1;\n}\n\n.formContainer {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.formDiv {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n.campoNumero {\n  width: 120px !important;\n}\n\n.filtrosTitulo {\n  margin-bottom: 8px !important;\n  font-weight: 600 !important;\n}\n\n.filtrosVazio {\n  padding: 8px 0 !important;\n}\n\n.filtrosLoading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n}\n\n/* Cabeçalho + até 5 linhas visíveis; rolagem se houver mais linhas ou conteúdo largo */\n.tabelaFiltros {\n  max-height: calc(48px + 5 * 2.5rem);\n  overflow-y: auto;\n  overflow-x: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"botaoPopupSalvar": `styles_botaoPopupSalvar__oaqKt`,
	"acoesForm": `styles_acoesForm__mQHd3`,
	"botaoPopupCancelar": `styles_botaoPopupCancelar__2MIiL`,
	"formContent": `styles_formContent__IiL0m`,
	"formContainer": `styles_formContainer__f-0pR`,
	"formDiv": `styles_formDiv__-x2nQ`,
	"campoNumero": `styles_campoNumero__patFJ`,
	"filtrosTitulo": `styles_filtrosTitulo__IBD9Z`,
	"filtrosVazio": `styles_filtrosVazio__h-H4-`,
	"filtrosLoading": `styles_filtrosLoading__O6UXU`,
	"tabelaFiltros": `styles_tabelaFiltros__UtHJe`
};
export default ___CSS_LOADER_EXPORT___;
